export * from './gauge.component';
export * from './gauge-options.component';
